// extracted by mini-css-extract-plugin
export var articleHeader = "styles-module--articleHeader--Dk9aJ";
export var contentInfo = "styles-module--contentInfo--hF+t0";
export var coverImage = "styles-module--coverImage--Z79eP";
export var emptyUpdatedDateMessage = "styles-module--emptyUpdatedDateMessage--Q0Jsj";
export var extendedInfo = "styles-module--extendedInfo--yw53J";
export var tags = "styles-module--tags--SPYop";
export var updatedDateMessage = "styles-module--updatedDateMessage--qFz2-";